import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";
import { PaymentMethodEnum } from "../../data/enums";

export namespace AgentPaymentValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const CreatePayment = defineValidation(
        v.object({
            method: v.picklist(PaymentMethodEnum.valuesCreate),
            paymentDate: baseVals.isoDate("Tanggal Pembayaran"),
            notes: v.optional(baseVals.stringEmptiable()),
        }),
    );
}
